import picture from 'assets/login.png';
import { isMobile } from 'react-device-detect';
import { ImageContainer } from './LoginForm.styles';

const LoginImage = () => {
  if (isMobile) {
    return null;
  }
  return (
    <ImageContainer>
      <img src={picture} alt="Login pic" />
    </ImageContainer>
  );
};

export default LoginImage;
